import { c as _c } from "react/compiler-runtime";
import { fetchBjAdminNoticeDetail, fetchBjAdminNoticeList, fetchBjNoticeDelete, fetchBjNoticeEdit, fetchBjNoticeIndex, fetchBjNoticeList, fetchBjNoticeWrite } from '@module/apis/client-side/notice';
import type { BjAdminNoticeDetailParams, BjAdminNoticeDetailResponse, BjAdminNoticeListParams, BjAdminNoticeListResponse, BjNoticeDeleteParams, BjNoticeEditParams, BjNoticeIndexParams, BjNoticeListParams, BjNoticeListResponse, BjNoticeWriteParams } from '@module/apis/client-side/notice/type';
import type { ApiBaseResponse } from '@module/apis/type';
import { type UseInfiniteQueryOptions, type UseMutationOptions, useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import type { CustomUseInfiniteQueryOptions, CustomUseQueryOptions } from '../type';
import { noticeQueryKeys } from './noticeQueryKeys';
export const useFetchBjAdminNoticeListQuery = (fetchBjAdminNoticeListParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchBjAdminNoticeListParams) {
    t0 = noticeQueryKeys.fetchBjAdminNoticeList(fetchBjAdminNoticeListParams);
    $[0] = fetchBjAdminNoticeListParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchBjAdminNoticeListParams) {
    t1 = () => fetchBjAdminNoticeList(fetchBjAdminNoticeListParams);
    $[2] = fetchBjAdminNoticeListParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useFetchBjAdminNoticeListInfiniteQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = noticeQueryKeys.fetchBjAdminNoticeList(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = t2 => {
      const {
        pageParam: t3
      } = t2;
      const pageParam = t3 === undefined ? 1 : t3;
      const actualPageParam = typeof pageParam === "number" ? pageParam : 1;
      const offset = params.limit * ((actualPageParam || 1) - 1);
      return fetchBjAdminNoticeList({
        ...params,
        offset
      });
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      initialPageParam: 1,
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options,
      getNextPageParam: _temp2,
      select: _temp4
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useInfiniteQuery(t2);
};
export const useFetchBjAdminNoticeDetailQuery = (fetchBjAdminNoticeDetailParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchBjAdminNoticeDetailParams) {
    t0 = noticeQueryKeys.fetchBjAdminNoticeDetail(fetchBjAdminNoticeDetailParams);
    $[0] = fetchBjAdminNoticeDetailParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchBjAdminNoticeDetailParams) {
    t1 = () => fetchBjAdminNoticeDetail(fetchBjAdminNoticeDetailParams);
    $[2] = fetchBjAdminNoticeDetailParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useFetchBjNoticeListQuery = (fetchBjNoticeListParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchBjNoticeListParams) {
    t0 = noticeQueryKeys.fetchBjNoticeList(fetchBjNoticeListParams);
    $[0] = fetchBjNoticeListParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchBjNoticeListParams) {
    t1 = () => fetchBjNoticeList(fetchBjNoticeListParams);
    $[2] = fetchBjNoticeListParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useFetchBjNoticeListInfiniteQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = noticeQueryKeys.fetchBjNoticeList(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = t2 => {
      const {
        pageParam: t3
      } = t2;
      const pageParam = t3 === undefined ? 1 : t3;
      const actualPageParam = typeof pageParam === "number" ? pageParam : 1;
      const offset = params.limit * ((actualPageParam || 1) - 1);
      return fetchBjNoticeList({
        ...params,
        offset
      });
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      initialPageParam: 1,
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options,
      getNextPageParam: _temp6,
      select: _temp8
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useInfiniteQuery(t2);
};
export const useFetchBjNoticeIndexInfiniteQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = noticeQueryKeys.fetchBjNotice(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = t2 => {
      const {
        pageParam: t3
      } = t2;
      const pageParam = t3 === undefined ? 1 : t3;
      const actualPageParam = typeof pageParam === "number" ? pageParam : 1;
      const offset = params.limit * ((actualPageParam || 1) - 1);
      return fetchBjNoticeIndex({
        ...params,
        offset
      });
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      initialPageParam: 1,
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options,
      getNextPageParam: _temp10,
      select: _temp12
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useInfiniteQuery(t2);
};
export const useBjNoticeWriteMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = noticeQueryKeys.fetchBjNoticeWrite();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp13,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const useBjNoticeEditMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = noticeQueryKeys.fetchBjNoticeEdit();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp14,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const useBjNoticeDeleteMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = noticeQueryKeys.fetchBjNoticeDelete();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp15,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
function _temp(page) {
  return page.list;
}
function _temp2(lastPage, allPages) {
  const totalFetchedItems = allPages.flatMap(_temp).length;
  if (totalFetchedItems < lastPage.page.total) {
    const nextPage = allPages.length + 1;
    return nextPage;
  }
}
function _temp3(page_0) {
  return page_0.list ?? [];
}
function _temp4(data) {
  return {
    pages: data?.pages.flatMap(_temp3),
    pageParams: data.pageParams,
    total: data?.pages.length > 0 ? data?.pages[0].page.total : 0
  };
}
function _temp5(page) {
  return page.list;
}
function _temp6(lastPage, allPages) {
  const totalFetchedItems = allPages.flatMap(_temp5).length;
  if (totalFetchedItems < lastPage.page.total) {
    const nextPage = allPages.length + 1;
    return nextPage;
  }
}
function _temp7(page_0) {
  return page_0.list ?? [];
}
function _temp8(data) {
  return {
    pages: data?.pages.flatMap(_temp7),
    pageParams: data.pageParams,
    total: data?.pages.length > 0 ? data?.pages[0].page.total : 0
  };
}
function _temp9(page) {
  return page.list;
}
function _temp10(lastPage, allPages) {
  const totalFetchedItems = allPages.flatMap(_temp9).length;
  if (totalFetchedItems < lastPage.page.total) {
    const nextPage = allPages.length + 1;
    return nextPage;
  }
}
function _temp11(page_0) {
  return page_0.list ?? [];
}
function _temp12(data) {
  return {
    pages: data?.pages.flatMap(_temp11),
    pageParams: data.pageParams,
    total: data?.pages.length > 0 ? data?.pages[0].page.total : 0
  };
}
function _temp13(bjNoticeWriteParams) {
  return fetchBjNoticeWrite(bjNoticeWriteParams);
}
function _temp14(bjNoticeEditParams) {
  return fetchBjNoticeEdit(bjNoticeEditParams);
}
function _temp15(bjNoticeDeleteParams) {
  return fetchBjNoticeDelete(bjNoticeDeleteParams);
}